import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { getKeyForValueFromMap } from "../get-key-for-value-from-map/get-key-for-value-from-map";
var urlSegmentOrderPriorities = new Map([
    [
        "make",
        1
    ],
    [
        "model",
        2
    ],
    [
        "trim",
        3
    ],
    [
        "fuelType",
        4
    ],
    [
        "colour",
        5
    ],
    [
        "bodyType",
        6
    ],
    [
        "gearbox",
        7
    ],
    [
        "doors",
        8
    ],
    [
        "seats",
        9
    ],
    [
        "driveType",
        10
    ], 
]);
var createReorderedParsedFilterMap = function(parsedFilterObject, orderedPrioritiesOfParsedFilterNames) {
    return orderedPrioritiesOfParsedFilterNames.reduce(function(reorderedParsedFilterMap, priority) {
        // get filterName for priority
        var filterName = getKeyForValueFromMap(urlSegmentOrderPriorities, priority);
        if (!filterName) {
            throw new Error("There is no filterName with priority ".concat(priority));
        }
        reorderedParsedFilterMap.set(filterName, parsedFilterObject[filterName]);
        return reorderedParsedFilterMap;
    }, new Map());
};
var isNumericArrayInAscendingOrder = function(array) {
    for(var i = 1; i < array.length; i++){
        if (array[i] < array[i - 1]) {
            return false;
        }
    }
    return true;
};
var getPrioritiesOfParsedFilterNames = function(filterNames) {
    return filterNames.map(function(filterName) {
        var priority = urlSegmentOrderPriorities.get(filterName);
        if (!priority) throw new Error("FilterName ".concat(filterName, " is unrecognised!"));
        return priority;
    });
};
var getOrderedPrioritiesOfParsedFilterNames = function(prioritiesOfParsedFilterNames) {
    return _to_consumable_array(prioritiesOfParsedFilterNames).sort(function(a, b) {
        return a - b;
    });
};
/**
 * Checks if the URL path is in order. If it is, it returns the original input path
 * otherwise it will sort and return the sorted path.
 * It also returns if the path was sorted
 * @param parsedFilterMap The parsed URL path
 * @returns A validated, sorted URL path and a boolean to indicate if this function sorted the path
 */ export function getOrderedParsedFilterMap(parsedFilterMap) {
    var parsedFilterObject = Object.fromEntries(parsedFilterMap);
    var filterNames = Object.keys(parsedFilterObject);
    var prioritiesOfParsedFilterNames = getPrioritiesOfParsedFilterNames(filterNames);
    if (!isNumericArrayInAscendingOrder(prioritiesOfParsedFilterNames)) {
        var orderedPrioritiesOfParsedFilterNames = getOrderedPrioritiesOfParsedFilterNames(prioritiesOfParsedFilterNames);
        var orderedParsedFilterMap = createReorderedParsedFilterMap(parsedFilterObject, orderedPrioritiesOfParsedFilterNames);
        return {
            wasParsedFilterMapReordered: true,
            orderedParsedFilterMap: orderedParsedFilterMap
        };
    }
    return {
        wasParsedFilterMapReordered: false,
        orderedParsedFilterMap: parsedFilterMap
    };
}
